import { useQuery } from "@tanstack/react-query";
import { axios } from "lib/axios";

export const getDenominationChurches = ({ denominationId, page, pageSize }) => {
  return axios.get(
    `/denominations/${denominationId}/denomination-churches?page=${page}&per_page=${pageSize}`
  );
};

export const useDenominationChurches = ({
  denominationId,
  page,
  pageSize,
  config
} = {}) => {
  return useQuery({
    ...config,
    queryKey: ["denomination-churches", denominationId, page, pageSize],
    queryFn: () => getDenominationChurches({ denominationId, page, pageSize })
  });
};
